import { render, staticRenderFns } from "./OpeSouvenir.vue?vue&type=template&id=699acaeb&scoped=true"
import script from "./OpeSouvenir.vue?vue&type=script&lang=js"
export * from "./OpeSouvenir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699acaeb",
  null
  
)

export default component.exports